var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-content__item-page ui-buttons ui-item-page" },
    [
      _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI Tag")]),
      _c("div", { staticClass: "ui-block" }, [
        _c("div", { staticClass: "row mb-30" }, [
          _c(
            "div",
            { staticClass: "col-lg-4" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Basic usage"),
              ]),
              _c("vue-tag", { attrs: { size: "mini" } }, [_vm._v("Tag Two")]),
              _c("vue-tag", { attrs: { type: "primary", size: "mini" } }, [
                _vm._v("Tag Two"),
              ]),
              _c("vue-tag", { attrs: { type: "success", size: "mini" } }, [
                _vm._v("Tag Two"),
              ]),
              _c("vue-tag", { attrs: { type: "info", size: "mini" } }, [
                _vm._v("Tag Three"),
              ]),
              _c("vue-tag", { attrs: { type: "warning", size: "mini" } }, [
                _vm._v("Tag Four"),
              ]),
              _c("vue-tag", { attrs: { type: "danger", size: "mini" } }, [
                _vm._v("Tag Five"),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-4" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Removable Tag"),
              ]),
              _vm._l(_vm.tags, function (tag) {
                return _c(
                  "vue-tag",
                  {
                    key: tag.name,
                    attrs: { closable: "", type: tag.type, size: "mini" },
                  },
                  [_vm._v(_vm._s(tag.name))]
                )
              }),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "row mb-30" }, [
          _c(
            "div",
            { staticClass: "col-lg-3" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Tag with Icon"),
              ]),
              _c(
                "vue-tag",
                { attrs: { icon: "fa fa-clock-o", size: "mini" } },
                [_vm._v("Info")]
              ),
              _c(
                "vue-tag",
                { attrs: { icon: "fa fa-check", type: "nmo", size: "mini" } },
                [_vm._v("HMO")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-lg-3" },
            [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("Sizes"),
              ]),
              _c("vue-tag", [_vm._v("Default")]),
              _c("vue-tag", { attrs: { size: "medium" } }, [_vm._v("Medium")]),
              _c("vue-tag", { attrs: { size: "small" } }, [_vm._v("Small")]),
              _c("vue-tag", { attrs: { size: "mini" } }, [_vm._v("Mini")]),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }